import { ActionExecutionRepository, ActionExecutionParams, ActionExecutionResult } from "../domain/ActionExecutionRepository";
import { ActionCatalogItem } from "../domain/Entities";

export interface ExecuteActionRequest {
  action_code: string;
  actions_catalog: ActionCatalogItem[];
  params: any;
  company_id: number;
}

export class ExecuteActionCommand {
  constructor(
    private readonly actionExecutionRepository: ActionExecutionRepository
  ) {}

  async execute(request: ExecuteActionRequest): Promise<ActionExecutionResult> {
    // Find the action in the catalog
    const action = request.actions_catalog.find(a => a.code === request.action_code);

    if (!action) {
      throw new Error(`Action not found: ${request.action_code}`);
    }

    // Prepare execution params
    const executionParams: ActionExecutionParams = {
      params: request.params,
      company_id: request.company_id,
      workflow_template_id: parseInt(action.workflow_id)
    };

    // Execute the action through the repository
    return await this.actionExecutionRepository.executeAction(executionParams);
  }
}
